export default __webpack_public_path__ + "static/media/Sample_File.9ec1c479.xlsx";